const PAGEVIEW = 'pageview';

export const TYPE_EVENTS_GA = {
  PAGEVIEW,
}